var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "__27AmV5i__Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 19.51",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#777",
    d: "M24,4.57a9.89,9.89,0,0,1-2.82.77,5,5,0,0,0,2.16-2.72A9.84,9.84,0,0,1,20.16,3.8a4.92,4.92,0,0,0-8.51,3.36,5.22,5.22,0,0,0,.13,1.13A14,14,0,0,1,1.64,3.16,4.79,4.79,0,0,0,1,5.64,4.9,4.9,0,0,0,3.16,9.73,5,5,0,0,1,.93,9.12v.06a4.92,4.92,0,0,0,4,4.82,5,5,0,0,1-1.3.17,5.5,5.5,0,0,1-.91-.08,4.94,4.94,0,0,0,4.6,3.42,9.92,9.92,0,0,1-6.1,2.1A9.18,9.18,0,0,1,0,19.54a14,14,0,0,0,7.56,2.21,13.9,13.9,0,0,0,14-14c0-.21,0-.42,0-.63A9.94,9.94,0,0,0,24,4.59Z",
    transform: "translate(0 -2.25)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.39b0e3ce9c734696e2e5f4220221df06.svg";
export { ForwardRef as ReactComponent };